import React from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

type AccordionContentProps = {
  className?: string
}

const AccordionContent = ({ children, className }: React.PropsWithChildren<AccordionContentProps>) => {
  const classes = useStyles()

  return <div className={clsx(classes.contentWithLeftSpace, className)}>{children}</div>
}

export default AccordionContent

export const useStyles = makeStyles({
  contentWithLeftSpace: {
    marginLeft: 10,
  },
})
